/**
 * WindowMessenger - Sends keepalive messages to parent window (EHR embed)
 */

class WindowMessenger {
  constructor(targetOrigin = '*') {
    this.targetOrigin = targetOrigin;
    this.isEnabled = window.self !== window.top; // Only enable if in iframe
    this.keepaliveInterval = null;
  }

  /**
   * Get current timestamp in ISO format with local timezone
   */
  getTimestamp() {
    return new Date().toISOString();
  }

  /**
   * Send keepalive message to parent window
   */
  sendKeepalive(userId) {
    if (!this.isEnabled) {
      console.log('WindowMessenger: Not in iframe, keepalive not sent');
      return;
    }

    const message = {
      id: userId,
      timestamp: this.getTimestamp(),
      messageType: 'Keepalive'
    };

    try {
      window.top.postMessage(message, this.targetOrigin);
      console.log('WindowMessenger: Keepalive sent', message);
    } catch (error) {
      console.error('WindowMessenger: Failed to send keepalive', error);
    }
  }

  /**
   * Start keepalive interval
   * @param {string} userId - User ID to include in messages
   * @param {number} intervalMs - Interval in milliseconds (default: 300000 = 5m)
   */
  startKeepalive(userId, intervalMs = 300000) {
    if (this.keepaliveInterval) {
      clearInterval(this.keepaliveInterval);
    }

    // Send immediately on start
    this.sendKeepalive(userId);

    // Then send on interval
    this.keepaliveInterval = setInterval(() => {
      this.sendKeepalive(userId);
    }, intervalMs);

    console.log(`WindowMessenger: Keepalive started (${intervalMs}ms interval) for user ${userId}`);
  }

  /**
   * Stop keepalive interval
   */
  stopKeepalive() {
    if (this.keepaliveInterval) {
      clearInterval(this.keepaliveInterval);
      this.keepaliveInterval = null;
      console.log('WindowMessenger: Keepalive stopped');
    }
  }
}

// Create singleton instance
const windowMessenger = new WindowMessenger('*');

export default windowMessenger;